"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractType = void 0;
var ContractType;
(function (ContractType) {
    ContractType["CONTRACT_MANAGER"] = "CONTRACT_MANAGER";
    ContractType["CLAIM"] = "CLAIM";
    ContractType["LOOT"] = "LOOT";
    ContractType["MYSTERY"] = "MYSTERY";
    ContractType["EXCHANGE"] = "EXCHANGE";
    ContractType["STAKING"] = "STAKING";
    ContractType["VESTING"] = "VESTING";
    ContractType["ERC20_TOKEN"] = "ERC20_TOKEN";
    ContractType["ERC721_TOKEN"] = "ERC721_TOKEN";
    ContractType["ERC721_TOKEN_RANDOM"] = "ERC721_TOKEN_RANDOM";
    ContractType["ERC998_TOKEN"] = "ERC998_TOKEN";
    ContractType["ERC998_TOKEN_RANDOM"] = "ERC998_TOKEN_RANDOM";
    ContractType["ERC1155_TOKEN"] = "ERC1155_TOKEN";
    ContractType["METADATA"] = "METADATA";
    ContractType["LOTTERY"] = "LOTTERY";
    ContractType["RAFFLE"] = "RAFFLE";
    ContractType["PONZI"] = "PONZI";
    ContractType["WAIT_LIST"] = "WAIT_LIST";
    ContractType["PAYMENT_SPLITTER"] = "PAYMENT_SPLITTER";
    ContractType["WRAPPER"] = "WRAPPER";
})(ContractType || (exports.ContractType = ContractType = {}));
//# sourceMappingURL=contract-manager.js.map